import React, { useRef }    from 'react';
import PropTypes            from 'prop-types';


import useTermsPage         from './useTermsPage';
import Header               from '../../components/Header';
import Footer               from '../../components/Footer';


import styles               from './TermsPage.styl';

function TermsPage() {
    // const { className, children, ...rest } = props;

    const introduction = useRef();
    const informationColect = useRef();
    const yourInformation = useRef();

    const refs = {
        introduction,
        informationColect,
        yourInformation
    }

    const {
        handleScrollTo
    } = useTermsPage(refs);

    return  (
        <div
            className = {styles.PrivacyPage}
        >
            <Header theme='light' />
            <div className={styles.content}>
                <div className={styles.leftBlock}>
                    <h3 className={styles.menuTitle}>
                    Terms of Service
                    </h3>
                    <ul className={styles.menuList}>
                        <li onClick={handleScrollTo('introduction')}>
                        Scope of License
                        </li>
                        <li onClick={handleScrollTo('informationColect')}>
                        License Restrictions
                        </li>
                        <li onClick={handleScrollTo('yourInformation')}>
                        Ownership
                        </li>
                        <li>
                        Consent to Use of Data
                        </li>
                        <li>
                        Termination
                        </li>
                        <li>
                        External Services
                        </li>
                        <li>
                        NO WARRANTY
                        </li>
                        <li>
                        INDEMNIFICATION
                        </li>
                        <li>
                        LIMITATION OF LIABILITY
                        </li>
                        <li>
                        Legal compliance
                        </li>
                        <li>
                        Government Rights
                        </li>
                        <li>
                        Governing Law; Jurisdiction
                        </li>
                        <li>
                        Severability
                        </li>
                        <li>
                        Assignment
                        </li>
                        <li>
                        Nonwaiver
                        </li>
                        <li>
                        Entire EULA
                        </li>
                    </ul>
                </div>
                <div className={styles.rightBlock}>
                    <h2 className={styles.title}>
                    Roimax Terms of Service
                    </h2>
                    <div className={styles.updatedTime}>
                    Last Updated August 11, 2022
                    </div>
                    <div className={styles.blockTitle}>
                    Roimax is a product developed by Playcus company.
                    </div>
                    <div className={styles.blockContent}>
                        <p>
                        Playcus’s mission is to connect the world through games. We deliver fun, social entertainment experiences to people around the world. In pursuit of our mission, we collect and use certain information from our players. Being transparent about our use of players’ information and respecting their privacy is incredibly important to Playcus.
                        </p>
                        <p>
                        This Privacy Policy applies when you use our Services (described below). Please read it before using Playcus’s Services because it will tell you how we collect, store, use, disclose, and otherwise process, your personal information when providing these Services to you. This Privacy Policy is not, however, a contract and does not create any legal rights or obligations.
                        </p>
                        <p>
                        If you have questions, comments, or concerns regarding our Privacy Policy or practices, please Contact Us.
                        </p>
                    </div>
                    <div ref={introduction} className={styles.blockTitle}>
                    Introduction
                    </div>
                    <div className={styles.blockContent}>
                        <p>
                        Playcus offers a variety of online and mobile games. Our Privacy Policy applies whenever you use our “Services,” which means our games, products, services, content, Playcus.com, and/or other domains or websites operated by Playcus. It describes the ways we use your information and your rights and choices concerning your information.
                        </p>
                        <p>
                        Playcus develops and publishes social games for web and mobile devices. “Playcus,” “we,” “our,” or “us” in this Privacy Policy refers to Playcus and any other corporate entities under common ownership with Playcus., including without limitation Playcus Limited (“Affiliated Entities”).
                        </p>
                        <p>
                        For purposes of data protection laws, Playcus. is the “data controller” of your personal information.
                        </p>
                        <p>
                        This Privacy Policy applies whenever you use our “Services,” which means our games, products, services, content, Playcus.com, and/or other domains or websites operated by Playcus. It describes how we collect, store, use, disclose, and otherwise process your personal information when providing these Services to you, and your rights and choices concerning your information.
                        </p>
                        <p>
                        If you do not want Playcus to collect, store, use, or share your information in the ways described in this Privacy Policy, you may not play Playcus’s games or use Playcus’s other Services.
                        </p>
                    </div>
                    <div ref = {informationColect} className={styles.blockTitle}>
                    Information We Collect and How We Collect It
                    </div>
                    <div className={styles.blockContent}>
                        <p>
                        We’ll collect and store any information that you provide to us, including when you create your account or a player profile.
                        </p>
                    </div>
                    <div ref={yourInformation} className={styles.blockTitle}>
                    Information About You That You Share With Us Directly
                    </div>
                    <div className={styles.blockContent}>
                        <p>
                        When you use our Services, you may give us information directly (like when you’re setting up your account), and we’ll store that information on our systems and use it for the purposes described in this Privacy Policy.
                        </p>
                        <p>
                        Some games or parts of our Services may use a more traditional registration or account set-up process where you may be asked to give us information like:
                        </p>
                        <ul>
                            <li>
                            your first and last name;
                            </li>
                            <li>
                            your username;
                            </li>
                            <li>
                            your gender;
                            </li>
                            <li>
                            your age or birthday;
                            </li>
                            <li>
                            your e-mail address;
                            </li>
                            <li>
                            a password; and/or other information that helps us to identify you or helps us to provide or improve our services.
                            </li>
                            <li>
                            Other important privacy information
                            </li>
                            <li>
                            Key Changes
                            </li>
                        </ul>
                        <p>
                        We may also let you create a player profile that other Playcus players can see. Your player profile may include information like:
                        </p>
                        <p>
                        If you do not want Playcus to collect, store, use, or share your information in the ways described in this Privacy Policy, you may not play Playcus’s games or use Playcus’s other Services.
                        </p>
                    </div>
                </div>
            </div>
            <Footer theme='light' />
        </div>
    );
}

TermsPage.propTypes = {
    className : PropTypes.string
};

TermsPage.defaultProps = {
    className : ''
};

export default TermsPage;
